import type { ControlEnv, ControlState } from '../controls/types';
import { riseToFlight } from '../controls/rise';

/** A boat tour ends in free flight at the boat's low eye, and rises from it. */
export function tourHandoff(state: ControlState, env: ControlEnv): ControlState {
  return state.mode === 'fly' ? riseToFlight(state, env) : state;
}
